import React, { forwardRef } from "react";
import { Form, Col, FormGroup, Row } from "react-bootstrap";
import { WrappedFieldProps, change, touch } from "redux-form";
import { Skeleton, RequiredMark } from "components";
import PhoneInput from "react-phone-number-input";
import { useLoader } from "hooks";
import clsx from "clsx";
import styles from "./input.module.scss";

export type InputProps = WrappedFieldProps & {
	name: string;
	label?: string;
	isLoading?: boolean;
	isRequired?: boolean;
	disabled?: boolean;
};

const ControlInput = forwardRef((controlProps: any, ref) => {
	return <Form.Control ref={ref} {...controlProps} />;
});

const PhoneInputRedux = ({
	input,
	meta: { error, touched, dispatch },
	label = "Phone",
	isLoading,
	isRequired = false,
	disabled,
	formName,
}: InputProps) => {
	const Loader = useLoader(isLoading);
	const invalidClass = touched && error && styles.errorField;
	const disabledInputClass = disabled && styles.disabledPhoneInput;

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		if (!e.target.value) {
			formName && dispatch(change(formName, input.name, ""));
		}

		formName && dispatch(touch(formName, input.name));
	};

	return (
		<FormGroup
			className={disabled && styles.disabledPhoneField}
			as={Row}
			controlId={input.name}
		>
			<Form.Label column sm={6}>
				{label}
				{isRequired && <RequiredMark />}
			</Form.Label>
			<Col sm={6}>
				<Loader
					skeleton={<Skeleton width="100%" height={34} />}
					component={
						<PhoneInput
							{...input}
							name={input.name}
							onBlur={handleBlur}
							defaultCountry="US"
							initialValueFormat="national"
							international={false}
							inputComponent={ControlInput}
							disabled={disabled}
							isInvalid={touched && !!error}
							className={clsx(invalidClass, disabledInputClass)}
						/>
					}
				/>
				{error && touched &&  (
					<div
						className="errorMessage"
						style={{
							display: "block",
							marginTop: "3px",
						}}
					>
						{error}
					</div>
				)}
			</Col>
		</FormGroup>
	);
};

export default PhoneInputRedux;
